import { useContext } from 'react';
import { RequestPaymentsContext, IRequestPaymentsContext } from 'context';

export function useRequestPayments(): IRequestPaymentsContext {
  return useContext(RequestPaymentsContext)!;
}
